import Vue from 'vue'
import App from './App.vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCircleChevronLeft,
  faPlus,
  faEnvelope,
  faCreditCard,
  faBarcode,
  faDownload,
  faChevronUp,  // Adicionado
  faChevronDown // Adicionado
} from '@fortawesome/free-solid-svg-icons'
import {
  faCopy,
  faXmarkCircle,
  faCheckCircle,
  faCircle
} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import VueTheMask from 'vue-the-mask'
import VeeValidate from 'vee-validate';
import VueFlashMessage from 'vue-flash-message';

import 'bulma/css/bulma.css'

// Vue Router
import router from './router'

library.add(faCircleChevronLeft)
library.add(faPlus)
library.add(faEnvelope)
library.add(faCreditCard)
library.add(faBarcode)
library.add(faCopy)
library.add(faXmarkCircle)
library.add(faCheckCircle)
library.add(faDownload)
library.add(faCircle)
library.add(faChevronUp)   // Adicionado
library.add(faChevronDown) // Adicionado
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VeeValidate);
Vue.use(VueFlashMessage);
Vue.use(VueNumberInput)
Vue.use(PiniaVuePlugin)
Vue.use(VueTheMask)
const pinia = createPinia()
Vue.config.productionTip = false

if (process.env.VUE_APP_IS_BLACK_NOVEMBER == 'true') {
  document.documentElement.style.setProperty('--primary-color', 'black');
  require('@/assets/black-november.scss')
} else {
  document.documentElement.style.setProperty('--primary-color', process.env.VUE_APP_PRIMARY_COLOR);
  require('@/assets/main.scss')
}

new Vue({
  router,
  pinia,
  render: h => h(App),
}).$mount('#app')
